export default "__VITE_ASSET__CRP_kzm8__"